import { Text, View } from '@react-pdf/renderer';

// Utils
import { isEmptyValueArray } from '@shared/utils';

// Types
import { FormSkill } from '@shared/types';

// Tokens
import { SECTION_TITLES } from '@/components/template/resume/Default/tokens';

// Styles
import styles from '../../style';
interface TechnicalSkillsSectionProps {
  technicalSkills: FormSkill[];
  technicalSkillsData: FormSkill[];
}
const TechnicalSkillsSection = ({
  technicalSkills,
  technicalSkillsData
}: TechnicalSkillsSectionProps) => {
  if (!technicalSkillsData || isEmptyValueArray(technicalSkillsData)) return null;
  return <View style={styles.sectionContainer} data-sentry-element="View" data-sentry-component="TechnicalSkillsSection" data-sentry-source-file="TechnicalSkills.tsx">
      <View style={[styles.divider, {
      marginBottom: 8,
      marginTop: 0
    }]} data-sentry-element="View" data-sentry-source-file="TechnicalSkills.tsx" />

      <Text style={styles.sectionTitle} data-sentry-element="Text" data-sentry-source-file="TechnicalSkills.tsx">{SECTION_TITLES.skills}</Text>
      {technicalSkills.map(skillCategory => {
      const {
        name = '',
        items = []
      } = skillCategory || {};
      return <View key={`skill-category-${name}`}>
            <Text style={styles.skillCategoryTitle}>{name}</Text>
            <View style={styles.skillList}>
              {items?.map(skill => {
            return <Text key={`${name}-${skill}`} style={styles.skillItem}>
                    • {skill}
                  </Text>;
          })}
            </View>
          </View>;
    })}
    </View>;
};
export default TechnicalSkillsSection;